<!-- Modal REVIEW DETAIL-->
<div class="modal fade contenedor-modal" id="modalReview" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content --cm-white-s-90">
            <div class="modal-body p-0">
                <app-modal-review [invert]="true" [review]="reviewSelected" (onClose)="closeReview()">
                </app-modal-review>
            </div>
        </div>
    </div>
</div>

<!-- ----------------------------------------------------------------------------------------------------------------- -->

<div class="row pantallaClara">
    <div class="col-12 px-xl-5 mt-5">

        <!-- Titulo -->
        <div class="row">
            <div class="col-12 my-4">
                <h1 class="text-black font-weight-bolder mb-0">
                    Mis comentarios y reseñas
                </h1>
                <p class="lead text-muted mb-0 animate__animated animate__fadeIn animate__faster">
                    Todos mis los comentarios y reseñas.
                </p>

                <div class="spinner-border mt-2" style="width: 3rem; height: 3rem" role="status" *ngIf="loading">
                    <span class="sr-only">Cargando...</span>
                </div>
            </div>
        </div>

        <!-- Paneles -->
        <div class="row">

            <div class="col-12 masonry-container">
                <div class="masonry-item mb-3" *ngFor="let review of reviews">

                    <div class="card card-body --cm-white-s-90 p-4" (click)="openReview(review)">

                        <div class="head">
                            <div class="title">{{review.movie.title}}</div>
                            <div class="date">{{review.createdTime | FormatDate}}</div>
                        </div>

                        <div class="d-flex  mb-4">
                            <span class="author mr-2">{{authorFullName(review)}}</span>
                            <app-raiting [score]="review.score"></app-raiting>
                        </div>

                        <p [innerHTML]="review.commentShort"> </p>

                    </div>

                </div>
            </div>

        </div>

    </div>
</div>